import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { FailedSolutionsSection } from './components/FailedSolutionsSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { TrustSection } from './components/TrustSection';
import { WhyItWorksSection } from './components/WhyItWorksSection';
import { PricingSection } from './components/PricingSection';
import { OrderBumpSection } from './components/OrderBumpSection';
import { FinalCloseSection } from './components/FinalCloseSection';
import { SalesFooter } from './components/SalesFooter';
export function App() {
  return <div className="min-h-screen bg-warm-white text-charcoal font-sans antialiased selection:bg-sage/30" data-id="element-0">
      <main className="flex flex-col w-full" data-id="element-1">
        {/* 1. Hero: Hook + Image + CTA + Prose */}
        <HeroSection data-id="element-2" />

        {/* 2. Pain: Agitate the problem */}
        <PainSection data-id="element-3" />

        {/* 3. Failed Solutions: Why other things didn't work */}
        <FailedSolutionsSection data-id="element-4" />

        {/* 4. Mechanism: The solution + Mid-page CTA */}
        <MechanismSection data-id="element-5" />

        {/* 5. Value Stack: What they get */}
        <WhatYouGetSection data-id="element-6" />

        {/* 6. Why It Works: Logic bridge before price */}
        <WhyItWorksSection data-id="element-7" />

        {/* 7. Pricing + Order Bump: The offer */}
        <PricingSection data-id="element-8" />
        <OrderBumpSection data-id="element-9" />

        {/* 8. Trust: Objection handling post-price */}
        <TrustSection data-id="element-10" />

        {/* 9. Final Close: Emotional appeal + CTA */}
        <FinalCloseSection data-id="element-11" />
      </main>
      <SalesFooter data-id="element-12" />
    </div>;
}